// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/chevron-left.js';

import { paths } from '../generated/chevron-left';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('chevron-left', Original, paths);
